import { render, staticRenderFns } from "./AboutPageAvailableData.vue?vue&type=template&id=78c0b4d8&scoped=true"
import script from "./AboutPageAvailableData.vue?vue&type=script&lang=js"
export * from "./AboutPageAvailableData.vue?vue&type=script&lang=js"
import style0 from "./AboutPageAvailableData.vue?vue&type=style&index=0&id=78c0b4d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0b4d8",
  null
  
)

export default component.exports